(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-basic-beanie-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-gm-basic-story]').forEach((section) => {
    const sources = JSON.parse(section.querySelector('[data-gm-basic-story-images]').textContent);
    document.addEventListener('product:variant-change', (event) => {
      const selected = sources[event.detail?.variant?.id];
      if (!selected) return;
      section.querySelectorAll('.gm-basic-story__media img').forEach((image, index) => {
        if (!selected[index]) return;
        image.src = selected[index];
        image.srcset = [480, 720, 960, 1220].map((width) => {
          const url = new URL(selected[index], window.location.origin);
          url.searchParams.set('width', width);
          return `${url.href} ${width}w`;
        }).join(', ');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-home-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gm-home-products'))customElements.define('gm-home-products',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.tabs=[...this.querySelectorAll('[role=tab]')];this.addEventListener('click',e=>{const tab=e.target.closest('[role=tab]');if(tab)this.select(tab)});this.addEventListener('keydown',e=>{if(!e.target.matches('[role=tab]'))return;let n=this.tabs.indexOf(e.target);if(e.key==='ArrowRight')n=(n+1)%this.tabs.length;else if(e.key==='ArrowLeft')n=(n-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else return;e.preventDefault();this.select(this.tabs[n]);this.tabs[n].focus()});this.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('.gm-home__panel');if(panel){const tab=this.tabs.find(t=>t.getAttribute('aria-controls')===panel.id);if(tab)this.select(tab)}})}select(tab){this.querySelectorAll('[data-gm-collection-link]').forEach(link=>{link.hidden=link.dataset.gmCollectionLink!==tab.getAttribute('aria-controls')});this.tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',active);t.classList.toggle('active',active);t.tabIndex=active?0:-1;this.querySelector('#'+CSS.escape(t.getAttribute('aria-controls'))).hidden=!active})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-kids-beanie-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-gm-kids-story]').forEach((section) => {
    const sources = JSON.parse(section.querySelector('[data-gm-kids-story-images]').textContent);
    document.addEventListener('product:variant-change', (event) => {
      const selected = sources[event.detail?.variant?.id];
      if (!selected) return;
      section.querySelectorAll('.gm-kids-story__media img').forEach((image, index) => {
        if (!selected[index]) return;
        image.src = selected[index];
        image.srcset = [480, 720, 960, 1220].map((width) => {
          const url = new URL(selected[index], window.location.origin);
          url.searchParams.set('width', width);
          return `${url.href} ${width}w`;
        }).join(', ');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-newsletter-invite"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gm-newsletter-invite')){
  customElements.define('gm-newsletter-invite',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.dialog=this.querySelector('dialog');
      document.querySelectorAll('[data-gm-newsletter-open]').forEach(trigger=>trigger.setAttribute('aria-controls',this.dialog.id));
      this.form=this.querySelector('form');
      this.storageKey='gm-newsletter-pending-'+this.dataset.formId;
      document.addEventListener('click',event=>{
        if(event.target.closest('[data-gm-newsletter-open]'))this.open();
      },options);
      this.querySelector('[data-newsletter-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const box=this.dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)this.dialog.close();}},options);
      this.dialog.addEventListener('close',()=>this.unlock(),options);
      document.addEventListener('keydown',event=>{
        if(event.key==='Escape'&&this.dialog.open){this.ownEscape=true;event.stopImmediatePropagation();}
      },{...options,capture:true});
      document.addEventListener('keyup',event=>{
        if(event.key==='Escape'&&this.ownEscape){this.ownEscape=false;event.stopImmediatePropagation();}
      },{...options,capture:true});
      this.form.addEventListener('submit',()=>{try{sessionStorage.setItem(this.storageKey,String(Date.now()));}catch{}},options);
      let pending=false;
      try{pending=Date.now()-Number(sessionStorage.getItem(this.storageKey)||0)<600000;}catch{}
      const ownAnchor=location.hash==='#'+this.dataset.formId;
      if(this.querySelector('[data-newsletter-result]')&&(pending||ownAnchor)){
        try{sessionStorage.removeItem(this.storageKey);}catch{}
        this.open();
      }
    }
    open(){
      if(this.dialog.open)return;
      this.returnFocus=document.activeElement;
      this.lockWasPresent=document.documentElement.classList.contains('gm-nl-scroll-lock');
      this.dialog.showModal();
      document.documentElement.classList.add('gm-nl-scroll-lock');
      const target=this.querySelector('[data-newsletter-result]')||this.querySelector('input[type=email]');
      if(target)target.focus({preventScroll:true});
    }
    unlock(){
      if(!this.lockWasPresent)document.documentElement.classList.remove('gm-nl-scroll-lock');
      if(this.returnFocus?.isConnected)this.returnFocus.focus({preventScroll:true});
    }
    disconnectedCallback(){
      if(this.dialog?.open){this.dialog.close();this.unlock();}
      this.controller?.abort();this.controller=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-plush-motif-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-plush-motif-story')) {
    customElements.define('gm-plush-motif-story', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-story-variants]').textContent);
        this.onVariantChange = (event) => {
          const variant = this.variants.find(item => item.id === event.detail?.variant?.id);
          const image = this.querySelector('.gm-plush-motif-story__image img');
          if (!variant?.featured_image?.src || !image) return;
          const url = new URL(variant.featured_image.src, location.origin);
          url.searchParams.set('width', '1000');
          image.removeAttribute('srcset');
          image.src = url.href;
        };
        document.addEventListener('product:variant-change', this.onVariantChange);
      }
      disconnectedCallback() {
        document.removeEventListener('product:variant-change', this.onVariantChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
